import React, { useState } from "react";
import { DataGridPro, frFR } from "@mui/x-data-grid-pro";
import moment from "moment";
import { ExpandMore } from "@mui/icons-material";
import {
    Grid,
    Box,
    Dialog,
    DialogContent,
    DialogContentText,
    Table,
    TableBody,
    TableContainer,
    Paper,
    AppBar,
    Toolbar,
    Alert,
    IconButton,
    TableRow,
    TableCell,
    Button,
    Typography,
    AlertTitle,
    Accordion,
    AccordionDetails,
    AccordionSummary,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { delete_inscription } from "./services";
import { toast } from "react-toastify";
import SearchBox from "./search_box";

function display_row(title, value) {
    if (!value) return;
    return (
        <TableRow>
            <TableCell align="center" style={{ width: 50 }}>
                <Box fontWeight="fontWeightMedium">{title}</Box>
            </TableCell>
            <TableCell style={{ width: 200 }} align="center">
                {value}
            </TableCell>
        </TableRow>
    );
}

// function displayWithIcon(value) {
//     if (value) {
//         return <Check style={{ color: "#5EC278" }} />;
//     }
//     return <Clear style={{ color: "#C25E5E" }} />;
// }

export default function InscriptionTableau({ inscriptions, update_inscription, height = 900 }) {
    const [inscription, set_inscription] = useState(null);
    const [displayed_inscriptions, set_displayed_inscriptions] = useState(inscriptions);

    let columns = [
        {
            field: "id",
            headerName: "ID",
            headerAlign: "center",
            align: "center",
            width: 80,
        },
        {
            field: "nom",
            headerName: "Nom",
            headerAlign: "center",
            width: 180,
        },
        {
            field: "prenom",
            headerName: "Prénom",
            headerAlign: "center",
            width: 180,
        },
        {
            field: "email",
            headerName: "Email",
            headerAlign: "center",
            width: 260,
        },
        {
            field: "date_creation",
            headerName: "Date création",
            headerAlign: "center",
            sortable: true,
            align: "center",
            width: 250,
            renderCell: ({ value }) => moment(value).format("ddd DD/MM/YYYY HH:mm"),
        },
        {
            field: "date_validation",
            headerName: "Date validation",
            headerAlign: "center",
            sortable: true,
            align: "center",
            width: 250,
            renderCell: ({ value }) => (value ? moment(value).format("ddd DD/MM/YYYY HH:mm") : ""),
        },
        {
            field: "uuid",
            headerName: "UUID",
            headerAlign: "center",
            width: 400,
        },
    ];

    const on_delete_inscription = async (id) => {
        toast.info("Suppresion en cours ...");
        try {
            const res = await delete_inscription(id);
            if (res.status < 200 || res.status >= 400) throw new Error("delete_inscription() returned an error status code");
            toast.success("Inscription supprimée ...");
        } catch (e) {
            console.log(e);
            toast.error("Erreur dans la suppression de l'inscription");
        }
        set_inscription(null);
    };

    const on_ticket_row_click = (e) => {
        if (e.field !== "id") return;
        set_inscription(e.row);
    };

    const handle_search = ({ query = "" }) => {
        if (query === "") {
            set_displayed_inscriptions(inscriptions);
            return;
        }
        let query_low = query;
        try {
            query_low = query.toLowerCase();
        } catch (e) {
            console.log(e);
        }
        const filtered_set = inscriptions.filter(
            (insc) =>
                insc.uuid?.toLowerCase().includes(query_low) ||
                insc.nom?.toLowerCase().includes(query_low) ||
                insc.prenom?.toLowerCase().includes(query_low) ||
                insc.email?.toLowerCase().includes(query_low),
        );

        set_displayed_inscriptions(filtered_set);
    };

    return (
        <React.Fragment>
            <Grid item md={12} xs={12}>
                <SearchBox label="Nom, prénom, email, ..." onSubmit={handle_search} />
            </Grid>
            <div style={{ height: height, width: "100%" }}>
                <DataGridPro
                    localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
                    disableColumnFilter
                    rows={displayed_inscriptions}
                    columns={columns}
                    onCellClick={(params, event) => {
                        if (!event.ctrlKey) {
                            event.defaultMuiPrevented = true;
                            on_ticket_row_click(params);
                        }
                        return;
                    }}
                />
            </div>

            <Dialog
                open={inscription}
                onClose={() => set_inscription(null)}
                fullScreen
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <AppBar sx={{ position: "relative" }}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={() => set_inscription(null)} aria-label="close">
                            <Close />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {inscription && (
                            <Grid container spacing={2} alignItems="center" justifyContent="center" sx={{ my: 1 }}>
                                <Grid item xs={12} md={12} align="center">
                                    <TableContainer component={Paper} sx={{ maxWidth: 900 }}>
                                        <Table sx={{ maxWidth: 900 }} aria-label="simple table" size="small">
                                            <TableBody>
                                                {display_row("ID", inscription.id)}
                                                {display_row("Nom", inscription.nom)}
                                                {display_row("Prénom", inscription.prenom)}
                                                {display_row("Téléphone", inscription.telephone)}
                                                {display_row("Email", inscription.email)}
                                                {display_row(
                                                    "Date inscription",
                                                    `${moment(inscription.date_creation).format("ddd DD/MM/YYYY HH:mm")}`,
                                                )}
                                                {inscription.date_validation &&
                                                    display_row(
                                                        "Date validation",
                                                        `${moment(inscription.date_validation).format("ddd DD/MM/YYYY HH:mm")}`,
                                                    )}
                                                {display_row("UUID", inscription.uuid)}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>

                                <Grid item md={12}>
                                    <Button variant="outlined" onClick={() => update_inscription(inscription.id)}>
                                        Marquer comme validée
                                    </Button>
                                </Grid>

                                <Grid item md={12}>
                                    <Accordion sx={{ mb: 2 }}>
                                        <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel1a-content" id="panel1a-header">
                                            <Typography>Suppression</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Alert severity="warning" sx={{ my: 2 }}>
                                                <AlertTitle>Attention</AlertTitle>
                                                Attention ! La suppression <strong>n'est pas réversible !</strong>
                                            </Alert>
                                            <Button
                                                variant="contained"
                                                color="error"
                                                onClick={async () => await on_delete_inscription(inscription.id)}
                                            >
                                                Supprimer cette inscription
                                            </Button>
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                            </Grid>
                        )}
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    );
}
